import React, { useState } from "react";
import { FormGroup, FormRow } from "styles/forms/main";
import { AccordionComponent, Input } from "components";
import EditHandler from "./EditHandler";

function OthersSection({ driverData, handleDataFroSubmit, isEditable, isEidtSection }) {
    const [isOnEdit, setIsOnEdit] = useState(false);

    return (
        <AccordionComponent
            title="Others"
            defaultExpanded
            extraAction={
                isEidtSection && (
                    <EditHandler
                        isOnEdit={isOnEdit}
                        setIsOnEdit={setIsOnEdit}
                    />
                )
            }
            body={
                <FormRow>
                    <FormGroup>
                        <Input
                            type="text"
                            isEditable={isEditable || isOnEdit}
                            placeholder="write your notes"
                            label="Note"
                            name="notes"
                            value={driverData}
                            onChange={(e) => handleDataFroSubmit(e)}
                        />
                    </FormGroup>
                </FormRow>
            }
        />
    );
}

export default OthersSection;
